







import {Prop, Vue, Component} from "vue-property-decorator";

@Component
export default class ConfirmButton extends Vue {
  @Prop(String) readonly status?: string;

  get statusClass(): Array<string> {
    if (!this.status) {
      return ['bg-gray-600']
    }
    if (this.status === 'good') {
      return ['bg-green-600']
    }
    if (this.status === 'bad') {
      return ['bg-red-600']
    }
    return [''];
  }

}
